function StreamModalController(stateService) {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.streams = ctrl.resolve.streams;
  };

  ctrl.selectStream = ($event, stream) => {
    $event.preventDefault();
    $event.stopPropagation();
    if (ctrl.selectedStream === stream) {
      ctrl.selectedStream = null;
    } else {
      ctrl.selectedStream = stream;
    }
  };

  ctrl.submit = () => {
    ctrl.close({ $value: ctrl.selectedStream });
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };
}

angular
  .module('pis-tool.module')
  .controller('StreamModalController', StreamModalController);
